// Centralized string pitch-name maps for the configurator, keyed by
// instrument slug + string count. Previously duplicated in GaugeStep and
// ColorStep — keep this the single source of truth.

// Full names (e.g. "High E", "Low E") for the gauge table / fretboard labels.
export const STRING_NOTES: Record<string, Record<number, string[]>> = {
  "electric-guitar": {
    6: ["High E", "B", "G", "D", "A", "Low E"],
    7: ["High E", "B", "G", "D", "A", "E", "Low B"],
    8: ["High E", "B", "G", "D", "A", "E", "B", "Low F#"],
  },
  "acoustic-guitar": {
    6: ["High E", "B", "G", "D", "A", "Low E"],
    12: ["e", "E", "b", "B", "g", "G", "d", "D", "a", "A", "e", "E"],
  },
  // Qualifiers ("High"/"Low") only where a pitch repeats in the set —
  // bass tunings are unique per string, so bare note names read cleaner.
  "bass-guitar": {
    4: ["G", "D", "A", "E"],
    5: ["G", "D", "A", "E", "B"],
    6: ["C", "G", "D", "A", "E", "B"],
  },
  "classical-guitar": { 6: ["High E", "B", "G", "D", "A", "Low E"] },
  "ukulele": { 4: ["A", "E", "C", "G"] },
};

// Short names (e.g. "E", "B") for compact per-string color rows.
export const STRING_NOTES_SHORT: Record<string, Record<number, string[]>> = {
  "electric-guitar": { 6: ["E", "B", "G", "D", "A", "E"], 7: ["E", "B", "G", "D", "A", "E", "B"], 8: ["E", "B", "G", "D", "A", "E", "B", "F#"] },
  "acoustic-guitar": { 6: ["E", "B", "G", "D", "A", "E"], 12: ["e", "E", "b", "B", "g", "G", "d", "D", "a", "A", "e", "E"] },
  "bass-guitar": { 4: ["G", "D", "A", "E"], 5: ["G", "D", "A", "E", "B"], 6: ["C", "G", "D", "A", "E", "B"] },
  "classical-guitar": { 6: ["E", "B", "G", "D", "A", "E"] },
  "ukulele": { 4: ["A", "E", "C", "G"] },
};

/** Full pitch names for an instrument+count, falling back to "String N". */
export function noteNamesFor(instrumentId: string | null, count: number): string[] {
  return (
    STRING_NOTES[instrumentId ?? ""]?.[count] ??
    Array.from({ length: count }, (_, i) => `String ${i + 1}`)
  );
}

/** Short pitch names for an instrument+count, falling back to "Str N". */
export function shortNoteNamesFor(instrumentId: string | null, count: number): string[] {
  return (
    STRING_NOTES_SHORT[instrumentId ?? ""]?.[count] ??
    Array.from({ length: count }, (_, i) => `Str ${i + 1}`)
  );
}
